// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formBoxStaticText {
  margin: 0px;
  padding: 5px;
}
.listgroup {
  width: 100%;
}
.listgroup h5 :global .highlighted {
  background-color: #C4408F;
  color: #FFFFFF;
}
.listgroup h5 :global .highlighter {
  display: inline;
}
.listgroup p :global .highlighted {
  background-color: #C4408F;
  color: #FFFFFF;
}
.listgroup p :global .highlighter:hover {
  background-color: #C4408F;
  color: #FFFFFF;
  cursor: pointer;
}
.listGroupItem:hover {
  background-color: #C4408F;
  color: #FFFFFF;
  cursor: pointer;
}
.textResults {
  font-size: 12px;
}
.listResults {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: auto;
}
#lookup-group-button {
  background-color: #3C6277;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/TextAreaLookupBox.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;AADF;AAIA;EACE,WAAA;AAFF;AACA;EAKQ,yBAAA;EACA,cAAA;AAHR;AAHA;EASQ,eAAA;AAHR;AANA;EAiBQ,yBAAA;EACA,cAAA;AARR;AAVA;EAqBQ,yBAAA;EACA,cAAA;EACA,eAAA;AARR;AAcA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AAZF;AAeA;EACE,eAAA;AAbF;AAgBA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAdF;AAiBA;EACE,yBAAA;AAfF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.formBoxStaticText {\n  margin: 0px;\n  padding: 5px;\n}\n\n.listgroup {\n  width: 100%;\n  h5 {\n    :global {\n      .highlighted {\n        background-color: @menu-primary;\n        color: @text-white;\n      }\n      .highlighter {\n        display: inline;\n      }\n    }\n  }\n\n  p {\n    :global {\n      .highlighted {\n        background-color: @menu-primary;\n        color: @text-white;\n      }\n      .highlighter:hover {\n        background-color: @menu-primary;\n        color: @text-white;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.listGroupItem:hover {\n  background-color: @menu-primary;\n  color: @text-white;\n  cursor: pointer;\n}\n\n.textResults {\n  font-size: 12px;\n}\n\n.listResults {\n  max-height: 500px;\n  overflow-y: scroll;\n  overflow-x: auto;\n}\n\n#lookup-group-button {\n  background-color: @secondary-color;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
